module.exports = __webpack_public_path__ + "img/dhw.03e9e374.png";